import React, { useState, useEffect } from 'react';
import { Col, Row, Modal, Button, Input, Space, notification, Tabs } from 'antd';
import { SettingFilled, DeleteFilled, PlusOutlined, SaveFilled } from '@ant-design/icons';
import { handleAddNewType, handleTypeChange, handleDeleteType, handleSaveTypes } from './dependencyTypeLogic';
import { handleAddNewAttribute, handleAttributeChange, handleDeleteAttribute, handleSaveAttributes } from './dependencyAttributeLogic'; 
import './DependencySettings.css';

const { TabPane } = Tabs;

const DependencySettings = (props) => {
  const { 
    isVisible, 
    onClose, 
    dependencyTypes, 
    attributes 
  } = props;
  
  const [api, contextHolder] = notification.useNotification();
  const [activeTab, setActiveTab] = useState('1');

  const [editedTypes, setEditedTypes] = useState([]);
  const [editedAttributes, setEditedAttributes] = useState([]);
  const [deletedTypes, setDeletedTypes] = useState([]); 
  const [deletedAttributes, setDeletedAttributes] = useState([]); 

  useEffect(() => {
    setEditedTypes(dependencyTypes || []);
    setEditedAttributes(attributes || []);
  }, [dependencyTypes, attributes]);
  
  useEffect(() => {
    if (!isVisible) {
      setDeletedTypes([]);
      setDeletedAttributes([]);
    }
  }, [isVisible]);

  return (
    <>
    {contextHolder}

    <Modal
      className="dependency-modal"
      title={
        <span>
          <SettingFilled style={{ marginRight: 8 }} />
          Configuración de Dependencias
        </span>
      }
      open={isVisible}
      onCancel={onClose}
      footer={[
        <Row>
          <Col>
            <Button key="cancel" className="cancel-button" onClick={onClose}>
              Cancelar
            </Button>
          </Col>
          <Col>
            <Button 
              className="save-type-button"
              icon={<SaveFilled />}
              onClick={async () => {
                if (activeTab === '1') {
                  await handleSaveTypes(editedTypes, deletedTypes, onClose, api);
                  /* setTimeout(() => {
                    window.location.reload();
                  }, 800); */
                } else {
                  await handleSaveAttributes(editedAttributes, deletedAttributes, onClose, api);
                  /* setTimeout(() => {
                    window.location.reload();
                  }, 800); */
                }
              }}
              >
              {activeTab === '1' ? 'Guardar Tipos' : 'Guardar Atributos'}
            </Button>
          </Col>
        </Row>
      ]}
    >
      <Tabs defaultActiveKey="1" onChange={setActiveTab}>
        <TabPane tab="Tipos de Dependencia" key="1">
          <div className="scrollable-tab-content">
            {editedTypes.map((type, index) => (
              <Row key={index} style={{ marginBottom: 8 }} gutter={[8, 0]}>
                <Col span={22}>
                  <Input 
                    style={{ width: '100%' }}
                    value={type.name} 
                    onChange={(e) => handleTypeChange(index, e.target.value, editedTypes, setEditedTypes)}
                    maxLength={50}
                  />
                {type.name && type.name.length >= 50 && (
                  <div style={{ color: 'red', fontSize: '12px', marginTop: '4px' }}>
                    Has alcanzado el límite de 50 caracteres
                  </div>)
                }
                </Col>
                <Col span={2}>
                  <Button 
                    className="delete-button"
                    icon={<DeleteFilled />} 
                    onClick={() => handleDeleteType(index, editedTypes, setEditedTypes, deletedTypes, setDeletedTypes, api)} 
                  />
                </Col>
              </Row>
            ))}
          </div>
          <div className="button-group">
            <Button className="add-type-button" icon={<PlusOutlined />} onClick={() => handleAddNewType(editedTypes, setEditedTypes)}>
              Agregar Tipo
            </Button>
          </div>
        </TabPane>

        <TabPane tab="Atributos de Dependencia" key="2">
          <div className="scrollable-tab-content">
            {editedAttributes.map((attribute, index) => (
              <Row key={index} style={{ marginBottom: 8 }} gutter={[8, 0]}>
                <Col span={22}>
                  <Input 
                    value={attribute.key} 
                    onChange={(e) => handleAttributeChange(index, e.target.value, editedAttributes, setEditedAttributes)}
                    maxLength={50}
                  />
                  {attribute.key && attribute.key.length >= 50 && (
                    <div style={{ color: 'red', fontSize: '12px', marginTop: '4px' }}>
                      Has alcanzado el límite de 50 caracteres
                    </div>)
                  }
                </Col>
                <Col span={2}>
                  <Button
                    className="delete-button"
                    icon={<DeleteFilled />} 
                    onClick={() => handleDeleteAttribute(index, editedAttributes, setEditedAttributes, deletedAttributes, setDeletedAttributes, api)} 
                    style={{ width: '100%' }}
                    />
                </Col>
              </Row>
            ))}
          </div>
          <div className="button-group">
            <Button className="add-type-button" icon={<PlusOutlined />} onClick={() => handleAddNewAttribute(editedAttributes, setEditedAttributes)}>
              Agregar Atributo
            </Button>
          </div>
        </TabPane>
      </Tabs>
    </Modal>
    </>
  );
};

export default DependencySettings;